<template>
  <div class="text-center max-w-3xl mx-auto" style="min-height: 80vh">
    <div class="grow flex flex-col justify-center">
      <h1 class="text-xl dark:text-white leading-loose">
        <span v-if="!route.query.message">Thank you for your submission.</span>
        <span v-else>{{ route.query.message }}</span>
      </h1>
    </div>
    <div class="mt-4 font-semibold dark:text-white leading-loose p-4">Your form has been submitted. You can now close this page.</div>
  </div>
</template>

<script setup lang="ts">
  import { useRoute } from 'vue-router';

  const route = useRoute();
</script>
